var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class ModelShelve {
    cdate;
    eventId;
    id;
    mdate;
    objId;
    objName;
    order;
    relativeId;
    title;
    type;
    userId;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelShelve.prototype, "cdate", void 0);
__decorate([
    Expose({ name: 'event_id' }),
    __metadata("design:type", String)
], ModelShelve.prototype, "eventId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelShelve.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelShelve.prototype, "mdate", void 0);
__decorate([
    Expose({ name: 'obj_id' }),
    __metadata("design:type", String)
], ModelShelve.prototype, "objId", void 0);
__decorate([
    Expose({ name: 'obj_name' }),
    __metadata("design:type", String)
], ModelShelve.prototype, "objName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelShelve.prototype, "order", void 0);
__decorate([
    Expose({ name: 'relative_id' }),
    __metadata("design:type", String)
], ModelShelve.prototype, "relativeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelShelve.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelShelve.prototype, "type", void 0);
__decorate([
    Expose({ name: 'user_id' }),
    __metadata("design:type", String)
], ModelShelve.prototype, "userId", void 0);
